import {createContext} from "react";

export const ModalContext = createContext({
    showModal: false,
    setShowModal: value => {},
    messageModal: "",
    setMessageModal: value => {},
    successModal: false,
    setSuccessModal: value => {}
});